// The only place that knows whether we run in a browser/PWA or a Capacitor
// native shell. Features call these helpers instead of platform APIs.

import { Capacitor } from '@capacitor/core';

export const isNative = (): boolean => Capacitor.isNativePlatform();

export const platformName = (): 'web' | 'android' | 'ios' => Capacitor.getPlatform() as 'web' | 'android' | 'ios';

export const isStandalonePwa = (): boolean =>
  typeof window !== 'undefined' &&
  (window.matchMedia?.('(display-mode: standalone)').matches ||
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true);
